import React, { useEffect, useState } from 'react';
import { DataTable, Pagination, StructuredListWrapper, StructuredListHead, StructuredListRow, StructuredListCell, StructuredListBody } from 'carbon-components-react';

import * as DashboardConstants from '../components/Dashboards/DashboardConstants';
import { getInputClassName } from 'antd/lib/input/Input';

export default function TableWithExpandedRowList(props) {
    const {
        Table,
        TableBody,
        TableCell,
        TableContainer,
        TableExpandHeader,
        TableExpandRow,
        TableExpandedRow,
        TableHead,
        TableHeader,
        TableRow,
    } = DataTable
    let headers = props.headers;
    const defaultFirstRowIndex = 0;
    const defaultCurrentPageSize = props.defaultCurrentPageSize || 5;
    const [paginatedRows, setPaginatedRows] = useState([]);
    const [totalItems, setTotalItems] = useState(0);
    const [firstRowIndex, setFirstRowIndex] = useState(defaultFirstRowIndex);
    const [currentPageSize, setCurrentPageSize] = useState(defaultCurrentPageSize);
    const [countryClickName, setCountryClickName] = useState(props.country);
    let dataValue = '';

    useEffect(() => {
        if (props.rows.length) {
            setTotalItems(props.rows.length);
            getPaginatedRows(defaultFirstRowIndex, defaultCurrentPageSize);
        }

    }, [props.rows])

    function getPaginatedRows(param, pageSize) {
        let startingIndex = Number.isInteger(param) ? param : firstRowIndex;
        let slicedRows = props.rows.slice(startingIndex, startingIndex + pageSize);
        setPaginatedRows(slicedRows);
    }

    useEffect(() => {
        props.handleCountryClick(countryClickName);

    }, [countryClickName])

    useEffect(() => {
        setCountryClickName(props.country);
    }, [props.country])



    function getRowClassName(row) {
        let country = row.cells[0].value;
        let classValue = '';
        let nodesList = document.querySelectorAll('.bx--parent-row');
        if (country === props.country) {
            let countryName = '';
            if (document.querySelector('.bx--parent-row.bx--expandable-row td')) {
                for (let j = 0; j < nodesList.length; j++) {
                    countryName = nodesList[j].childNodes[1].innerHTML;
                    if (countryName === props.country) {
                        if (nodesList[j].childNodes[0].hasAttribute('data-previous-value')) {
                            //document.querySelector('.bx--parent-row.bx--expandable-row td').removeAttribute('data-previous-value');
                            //nodesList[i].childNodes[0].childNodes[0].setAttribute('aria-label','Collapse current row');
                            //const classLists = document.querySelector('.bx--parent-row.bx--expandable-row td')
                            nodesList[j].classList.remove('.bx--expandable-row');

                        }
                        else {
                            nodesList[j].childNodes[0].setAttribute('data-previous-value', 'collapsed');
                            console.log(nodesList[j].childNodes[0]);
                            nodesList[j].childNodes[0].childNodes[0].setAttribute('aria-label', 'Collapse current row');
                            nodesList[j].classList.add('bx--expandable-row');
                        }
                    }
                }
            }
            else {
                //classValue = 'bx--expandable-row';
                for (let i = 0; i < nodesList.length; i++) {
                    console.log(nodesList[i].innerhtml);
                    countryName = nodesList[i].childNodes[1].innerHTML;
                    console.log(countryName);
                    if (countryName === props.country) {
                        nodesList[i].childNodes[0].setAttribute('data-previous-value', 'collapsed');
                        console.log(nodesList[i].childNodes[0]);
                        nodesList[i].childNodes[0].childNodes[0].setAttribute('aria-label', 'Collapse current row');
                        nodesList[i].classList.add('bx--expandable-row');
                        //classValue = 'bx--expandable-row';
                    }
                }

            }
            setCountryClickName('');
            //handleCountryClick();
        }
        else {
            if (document.querySelector('.bx--parent-row.bx--expandable-row td')) {
                let regionName = '';
                for (let j = 0; j < nodesList.length; j++) {
                    regionName = nodesList[j].childNodes[1].innerHTML;
                    if (regionName === country) {
                        if (nodesList[j].childNodes[0].hasAttribute('data-previous-value')) {
                            nodesList[j].classList.remove('.bx--expandable-row');

                        }
                    }
                }
            }
        }

        return classValue;
    }

    return (
        <div>
            <DataTable
                rows={paginatedRows}
                headers={headers}
                isExpandable={props.isExpandable}
                isSortable={props.isSortable}
                sortDirection="Ascend"
            >
                {({
                    rows,
                    headers,
                    getHeaderProps,
                    getRowProps,
                    getTableProps,
                    getTableContainerProps,
                }) => (
                    <TableContainer
                        {...getTableContainerProps()}>
                        <Table {...getTableProps()} size="xl">
                            <TableHead>
                                <TableRow>
                                    <TableExpandHeader id="expand" />
                                    {headers.map((header, i) => (
                                        <TableHeader
                                            id={header.header}
                                            key={i}
                                            {...getHeaderProps({ header })}>
                                            {header.header}
                                        </TableHeader>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rows.map((row, i) => (
                                    <React.Fragment key={row.id}>
                                        <TableExpandRow
                                            id='expanded-row'
                                            className={getRowClassName(row)}
                                            {...getRowProps({ row })}>
                                            {row.cells.map((cell) => (
                                                <TableCell key={cell.id}>{cell.value}</TableCell>
                                            ))}
                                        </TableExpandRow>
                                        {(row.isExpanded || props.userData) && (
                                            <TableExpandedRow
                                                colSpan={headers.length + 1}

                                            >
                                                <StructuredListWrapper>
                                                    <StructuredListHead>
                                                        <StructuredListRow head tabIndex={0}>
                                                            {props.expandedRowHeaders.map((item) => {
                                                                return <StructuredListCell head>
                                                                    {item.header}
                                                                </StructuredListCell>
                                                            })}
                                                        </StructuredListRow>
                                                    </StructuredListHead>
                                                    <StructuredListBody>
                                                        {props.expandedRowList.map((item) => {
                                                            let objArr = Object.entries(item);
                                                            return (
                                                                <StructuredListRow>
                                                                    {objArr.map((item) => {
                                                                        return (
                                                                            <StructuredListCell>
                                                                                {item[1]}
                                                                            </StructuredListCell>
                                                                        )
                                                                    })}
                                                                </StructuredListRow>
                                                            )
                                                        })}
                                                    </StructuredListBody>
                                                </StructuredListWrapper>
                                            </TableExpandedRow>
                                        )}
                                    </React.Fragment>

                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </DataTable>
            {props.showPagination && props.rows.length > (props.tablePaginationLimit || 5) &&
                <Pagination
                    totalItems={totalItems}
                    backwardText={DashboardConstants.Previouspage}
                    forwardText={DashboardConstants.NextPage}
                    pageSize={props.defaultCurrentPageSize || 5}
                    pageSizes={[5, 10, 15, 25]}
                    itemsPerPageText={DashboardConstants.Itemspage}
                    onChange={({ page, pageSize }) => {
                        let newFirstRowIndex = pageSize * (page - 1);
                        setFirstRowIndex(newFirstRowIndex)
                        getPaginatedRows(newFirstRowIndex, pageSize);
                    }}
                />}
        </div>
    )
}
